import React, { useCallback, useEffect, useState } from "react";
import { HeroSm, MyInput, MySelect, NavBar, Spinner } from "../../components";
import { Footer } from "../../layouts";
import $ from "jquery";
import axios from "axios";
import config from "../../config";
import { Link } from "react-router-dom";
import {
  GoogleReCaptcha,
  GoogleReCaptchaProvider,
} from "react-google-recaptcha-v3";
import { useNavigate } from "react-router-dom";
// import { fetchWrapper } from "../../helpers/fetch-wrapper";
import { Slang, passwordFormatReg } from "../../helpers";
import { toast } from "react-toastify";
import { authActions } from "../../store";
import { useDispatch } from "react-redux";
import countriesJson from "../../constants/countries.json";
import { fetchWrapper } from "../../helpers/fetch-wrapper";

// import { useTranslation } from "react-i18next";
// import { set } from "local-storage";

const RegisterUser = () => {
  const [loadPage, setLoadPage] = useState(true);
  // const [spinColor, setSpinColor] = useState("success");
  // const clrs = ["primary", "body", "success", "info", "danger", "warning", "info", "success", "light", ""];

  useEffect(() => {
    // let tim1 = setInterval(() => {
    //     setSpinColor(clrs[parseInt(Math.random() * 10)]);
    // }, 2000);

    let tim1 = setTimeout(() => {
      setLoadPage(false);
    }, 100);

    return () => {
      clearInterval(tim1);
    };
  }, []);

  return (
    <>
      {loadPage ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              width: "100%",
              position: "fixed",
              left: 0,
              top: 0,
            }}
          >
            <Spinner color={"success"} size={3} />
          </div>
        </>
      ) : (
        // userType === null ? (
        //   <UserTypeSelection setUserType={setUserType} />
        // ) :
        <Main />
      )}

      {/*<Helmet>*/}
      {/*	/!* <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap" rel="stylesheet" /> *!/*/}
      {/*	<title>Register your Business</title>*/}
      {/*	<link rel="stylesheet" href="./assets/css/bootstrap/icons/bootstrap-icons.css" />*/}
      {/*	<link rel="stylesheet" href="./assets/css/hs/mega-menu/mega-menu.min.css" />*/}
      {/*	<link rel="stylesheet" href="./assets/css/_theme.css" />*/}

      {/*	<script defer asyn src="./assets/js/bootstrap/bootstrap.bundle.min.js"></script>*/}
      {/*	<script defer asyn src="./assets/js/hs/go-to/goto.min.js"></script>*/}
      {/*	<script defer asyn src="./assets/js/prism/prism.js"></script>*/}
      {/*	<script defer asyn src="./assets/js/hs/show-animation/show-animation.min.js"></script>*/}
      {/*	<script defer asyn src="./assets/js/hs/mega-menu/mega-menu.min.js"></script>*/}
      {/*	<script defer asyn src="./assets/js/hs/header/header.min.js"></script>*/}
      {/*	<script defer asyn src="./assets/js/fslightbox/index.js"></script>*/}
      {/*	<script defer asyn src="./assets/js/theme.min.js"></script>*/}

      {/*</Helmet>*/}
    </>
  );
};

export default RegisterUser;

// const UserTypeSelection = ({ setUserType }) => {
//   return (
// <div className=" container ">
//   <div className=" text-center mt-10">
//     <h1> Vous voulez créer un compte en tant que :</h1>
//     <div className="mt-4 ">
//       <button
//         onClick={() => setUserType("supplier")}
//         className="btn btn-primary btn-lg mx-2"
//       >
//         Supplier ?
//       </button>
//       <button
//         onClick={() => setUserType("customer")}
//         className="btn btn-primary btn-lg mx-2"
//       >
//         Customer ?
//       </button>
//       or
//       <button
//         onClick={() => setUserType("company")}
//         className="btn btn-primary btn-lg mx-2"
//       >
//         Company ?
//       </button>
//     </div>
//   </div>
// </div>
//   );
// };

const Main = () => {
  const [token, setToken] = useState(null);
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
  const [categories, setCategories] = useState(null);
  const [countries, setCountries] = useState(null);
  const [subCategories, setSubCategories] = useState(null);
  const [code, setCode] = useState("Empty");
  const [submitted, setSubmitted] = useState(false);
  const [formValid, setFormValid] = useState(false);
  const [passwordError, setPasswordError] = useState(null);
  const [passwordMatchError, setPasswordMatchError] = useState(null);
  const navigate = useNavigate();
  const lang = Slang("Register");
  const pInfoLang = Slang("Register.PersonnalsInfo");
  const cInfoLang = Slang("Register.CompanyInfo");
  const passwordValLang = Slang("Validation.password");
  const dispatch = useDispatch();

  const [userType, setUserType] = useState(null);
  const userTypeLang = Slang("Register.UserType");

  const getCategories = async () => {
    const { data } = await axios.get(`${config.apiUrl}/categories`, {});
    console.log("categorie", data.data.categories);
    setCategories(data.data.categories);
  };

  const getCountries = async () => {
    // const { data } = await axios.get(`${config.get_json_json}`, {});
    // setCountries(data.countries);
    console.log(countriesJson.countries);
    setCountries(countriesJson.countries);
  };

  useEffect(() => {
    const script = `
            new HSGoTo('.js-go-to');
            new HSHeader('#header').init();
            new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
        `;
    if(userType === "company") {
      getCountries();
      getCategories();
    }
    // getCountries();
    // getCategories();
    getIpAddress();

    $("body").append(`<script className="homescript">${script}</script>`);

    return () => {
      $(".homescript").remove();
    };
  }, [userType]);

  const [data, setData] = useState({
    first_name: "",
    last_name: "",
    ip: "",
    phone: "",
    email: "",
    password: "",
    confirm_password: "",
    isInvestor: 0,
    c_name: "",
    c_category_id: "",
    sub_category_id: null,
    c_email: "",
    c_phone: "",
    c_domaine: "",
    c_country: "",
    c_description: "",
    c_logo: null,
    recaptchaToken: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "password") {
      validatePassword(value);
    }
    if (name === "confirm_password") {
      validateConfirmPassword(data.password, value);
    }
    if (name === "c_category_id") {
      changeSubCategory(value);
    }
    setData({ ...data, [name]: value });
  };

  const changeSubCategory = (subCatId) => {
    axios
      .get(`${config.apiUrl}/get-sub-by-category-id/${subCatId}`)
      .then((response) => {
        setSubCategories(response.data.data);
      });
  };

  const setInvestor = (value) => {
    setData({ ...data, isInvestor: value });
  };

  const setLogo = (e) => {
    // console.log(e.target.files[0]);
    setData({ ...data, c_logo: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formValid) {
      toast.info("Form contains errors");
      return;
    }
    setSubmitted(true);
    const recaptchaToken = sessionStorage.getItem("reCaptchaToken");
    const ip = sessionStorage.getItem("ip");

    const body = {
      account_type: userType,
      first_name: data.first_name,
      last_name: data.last_name,
      phone: data.phone,
      email: data.email,
      password: data.password,
      // confirm_password: data.confirm_password,
      isInvestor: data.isInvestor,
      recaptchaToken,
      ip,
    };

    if (userType === "company") {
      body.company = {
        name: data.c_name,
        category_id: data.c_category_id,
        sub_category_id: data.sub_category_id,
        email: data.c_email,
        phone: data.c_phone,
        country: code.name,
        domaine: data.c_domaine,
        description: data.c_description,
        logo: data.c_logo,
      };
    }

    // console.log(body);

     axios
      .post(`${config.apiUrl}/user/register`, body, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log("response submitted", response);
        storeUserInfo(response.data);
        sessionStorage.setItem("token", response.data.data.token.value);
        navigate("/verify-email");
      })
      .catch((e) => {
        // console.error("Error", e);
        console.log("response submitted", e);
        setSubmitted(false);
        setRefreshReCaptcha((r) => !r);
      });

    // fetchWrapper
    //   .post(`${config.apiUrl}/user/register`, body, {
    //     headers: {
    //       "Content-Type": "multipart/form-data",
    //     },
    //   })
    //   .then((response) => {
    //     console.log("response submitted", response);
    //     storeUserInfo(response.data);
    //     sessionStorage.setItem("token", response.data.token.value);
    //     navigate("/verify-email");
    //   })
    //   .catch((e) => {
    //     console.log("response submitted", e);
    //     setSubmitted(false);
    //     setRefreshReCaptcha((r) => !r);
    //   });
  };

  const handleChangeCountry = (e) => {
    const { name, value } = e.target;

    setCode(countries.filter((country) => country.name === value)[0]);
    setData({ ...data, [name]: value });
  };

  const getIpAddress = () => {
    axios.get("https://api.ipify.org/?format=json").then((response) => {
      sessionStorage.setItem("ip", response.data.ip);
      setData({ ...data, ip: response.data.ip });
    });
  };

  const storeUserInfo = (data) => {
    dispatch(authActions.setToken(data.token));
  };

  const onVerify = useCallback((token) => {
    sessionStorage.setItem("reCaptchaToken", token);
    setToken(token);
  }, []);

  const validatePassword = (text) => {
    const result = passwordFormatReg(text);

    if (!result.size) {
      setPasswordError(passwordValLang("p1"));
      setFormValid(false);
    } else if (!result.lower) {
      setPasswordError(passwordValLang("p2"));
      setFormValid(false);
    } else if (!result.upper) {
      setPasswordError(passwordValLang("p3"));
      setFormValid(false);
    } else if (!result.number) {
      setPasswordError(passwordValLang("p4"));
      setFormValid(false);
    } else if (!result.special) {
      setPasswordError(passwordValLang("p5"));
      setFormValid(false);
    } else {
      setPasswordError(null);
      setFormValid(true);
    }
  };

  const validateConfirmPassword = (password, confirm) => {
    if (password !== confirm) {
      setPasswordMatchError(passwordValLang("p6"));
      setFormValid(false);
    } else {
      setPasswordMatchError(null);
      setFormValid(true);
    }
  };

  return (
    <>
      <NavBar />

      <HeroSm title={lang("t1")} />
      <main id="content" role="main" style={{ background: "#c6ffd3" }}>
        <div className="container  content-space-6 content-space-t-lg-1 content-space-b-lg-3">
          <div className="flex-grow-1 mx-auto" style={{ maxWidth: "100rem" }}>
            {userType === null ? (
              <div className=" text-center mb-10 ">
                <h1> {lang("14")} </h1>
                <div className="mt-4 ">
                  <button
                    onClick={() => setUserType("supplier")}
                    className="btn btn-primary btn-lg mx-2"
                  >
                    {userTypeLang("t3")}
                  </button>
                  <button
                    onClick={() => setUserType("customer")}
                    className="btn btn-primary btn-lg mx-2"
                  >
                    {userTypeLang("t2")}
                  </button>

                  <button
                    onClick={() => setUserType("company")}
                    className="btn btn-primary btn-lg mx-2"
                  >
                    {userTypeLang("t1")}
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div className="text-center mb-5 mb-md-7">
                  <h1 className="h2">
                    <img
                      src="./assets/img/logos/155x47/initial/PNG/init_gradient.png"
                      alt="logo"
                      style={{ height: "7vh" }}
                    />
                  </h1>
                  <p>
                    {userType === "company"
                      ? lang("t2")
                      : userType === "supplier"
                      ? lang("12")
                      : lang("13")}
                  </p>
                </div>

                <form onSubmit={handleSubmit}>
                  <fieldset
                    style={{
                      backgroundColor: "rgba(1, 129, 86, 0.3)",
                      padding: 10,
                      borderRadius: 5,
                      color: "black",
                      boxShadow: "2px 2px 1px rgba(0, 0, 0, 0.01)",
                    }}
                  >
                    <legend className="fw-bold">{pInfoLang("t1")}</legend>
                    <div className="row">
                      <div className="col-md-4 col-sm-12">
                        <MyInput
                          required={true}
                          handleChange={handleChange}
                          id="first_name"
                          name="first_name"
                          placeholder={pInfoLang("t2")}
                          label={pInfoLang("t2")}
                        />
                      </div>

                      <div className="col-md-4 col-sm-12">
                        <MyInput
                          required={true}
                          handleChange={handleChange}
                          id="last_name"
                          name="last_name"
                          placeholder={pInfoLang("t3")}
                          label={pInfoLang("t3")}
                        />
                      </div>

                      <div className="col-md-4 col-sm-12">
                        <MyInput
                          required={true}
                          handleChange={handleChange}
                          id="email"
                          name="email"
                          placeholder="email@site.com"
                          type="email"
                          label={pInfoLang("t4")}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-4 col-sm-12">
                        <MyInput
                          required={true}
                          handleChange={handleChange}
                          id="phone"
                          name="phone"
                          placeholder={pInfoLang("t5")}
                          label={pInfoLang("t5")}
                          type="tel"
                        />
                      </div>

                      <div className="col-md-4 col-sm-12">
                        <MyInput
                          required={true}
                          handleChange={handleChange}
                          id="password"
                          name="password"
                          placeholder={pInfoLang("t6")}
                          label={pInfoLang("t6")}
                          type="password"
                          error={passwordError}
                        />
                      </div>

                      <div className="col-md-4 col-sm-12">
                        <MyInput
                          required={true}
                          handleChange={handleChange}
                          id="confirm_password"
                          name="confirm_password"
                          placeholder={pInfoLang("t7")}
                          label={pInfoLang("t7")}
                          type="password"
                          error={passwordMatchError}
                        />
                      </div>
                    </div>
                  </fieldset>

                  <br />

                  {userType === "company" ? (
                    <fieldset
                      style={{
                        backgroundColor: "rgba(1, 129, 86, 0.3)",
                        padding: 10,
                        borderRadius: 5,
                        color: "black",
                        boxShadow: "2px 2px 1px rgba(0, 0, 0, 0.01)",
                        marginBottom: "2vh",
                      }}
                    >
                      <legend className="fw-bold">{cInfoLang("t1")}</legend>

                      <div className="row">
                        <div className="col-md-3 col-sm-12">
                          <MyInput
                            required={true}
                            handleChange={handleChange}
                            label={cInfoLang("t2")}
                            id="c_name"
                            name="c_name"
                            placeholder={cInfoLang("t3")}
                            type="text"
                          />
                        </div>

                        <div className="col-md-3 col-sm-12">
                          <MySelect
                            required={true}
                            handleChange={handleChange}
                            id="c_category_id"
                            name="c_category_id"
                            label={cInfoLang("t4")}
                            values={categories}
                          />
                        </div>
                        <div className="col-md-3 col-sm-12">
                          <MySelect
                            required={true}
                            handleChange={handleChange}
                            id="sub_category_id"
                            name="sub_category_id"
                            label={cInfoLang("t13")}
                            values={subCategories}
                          />
                        </div>

                        <div className="col-md-3 col-sm-12">
                          <MyInput
                            required={true}
                            handleChange={setLogo}
                            label={cInfoLang("t14")}
                            id="c_logo"
                            name="c_logo"
                            // placeholder={cInfoLang("t14")}
                            type="file"
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-3 col-sm-12">
                          <MyInput
                            required={true}
                            handleChange={handleChange}
                            label={cInfoLang("t5")}
                            id="c_email"
                            name="c_email"
                            placeholder="user@company.com"
                            type="email"
                          />
                        </div>

                        <div className="col-md-3 col-sm-12">
                          <label
                            className="form-label text-primary fw-bold"
                            htmlFor="c_country"
                          >
                            {cInfoLang("t6")}
                          </label>
                          <select
                            name="c_country"
                            id="c_country"
                            onChange={handleChangeCountry}
                            className="form-control form-control-lg"
                          >
                            <option value={null}> -- --</option>
                            {countries !== null
                              ? countries.map((country, idx) => (
                                  <option key={idx} value={country.name}>
                                    {country.emoji} ({country.dial_code})&nbsp;{" "}
                                    {country.name}
                                  </option>
                                ))
                              : null}
                          </select>
                        </div>

                        <div className="col-md-3 col-sm-9">
                          <MyInput
                            required={true}
                            handleChange={handleChange}
                            label={cInfoLang("t7")}
                            id="c_phone"
                            name="c_phone"
                            placeholder={cInfoLang("t8")}
                            type="tel"
                          />
                        </div>

                        <div className="col-md-3 col-sm-12">
                          <MyInput
                            required={true}
                            handleChange={handleChange}
                            label={cInfoLang("t9")}
                            id="c_domaine"
                            name="c_domaine"
                            placeholder={cInfoLang("t10")}
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12 col-sm-12">
                          <label
                            className="form-label text-primary fw-bold"
                            htmlFor="c_description"
                          >
                            {cInfoLang("t11")}
                          </label>
                          <textarea
                            required
                            onChange={handleChange}
                            name="c_description"
                            id="c_description"
                            cols="30"
                            rows="20"
                            className="form-control form-control-lg"
                            placeholder={cInfoLang("t12")}
                          ></textarea>
                        </div>
                      </div>

                      <div className="mt-5 col-2 offset-5">
                        <label
                          htmlFor="isInvestor"
                          className="form-label text-dark"
                        >
                          Are you an investor?
                        </label>

                        <div className="d-flex mb-5 mt-5">
                          <div className="form-check form-check-inline">
                            <input
                              type="radio"
                              id="formInlineRadio2"
                              onClick={() => setInvestor(1)}
                              className="form-check-input indeterminate-checkbox"
                              name="formInlineRadio"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="formInlineRadio2"
                              onClick={() => setInvestor(1)}
                            >
                              Yes
                            </label>
                          </div>

                          <div className="form-check form-check-inline">
                            <input
                              type="radio"
                              id="formInlineRadio3"
                              onClick={() => setInvestor(0)}
                              className="form-check-input indeterminate-checkbox"
                              name="formInlineRadio"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="formInlineRadio3"
                              onClick={() => setInvestor(0)}
                            >
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  ) : null}

                  <div className="form-check mb-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="signupHeroFormPrivacyCheck"
                      name="signupFormPrivacyCheck"
                      required
                    />
                    <label
                      className="form-check-label small"
                      htmlFor="signupHeroFormPrivacyCheck"
                    >
                      {" "}
                      By submitting this form I have read and acknowledged the{" "}
                      <Link to="#/">Privacy Policy</Link>
                    </label>
                    <span className="invalid-feedback">
                      Please accept our Privacy Policy.
                    </span>
                  </div>
                  <GoogleReCaptchaProvider
                    reCaptchaKey={config.googleReCaptchaClientId}
                  >
                    <GoogleReCaptcha
                      className="google-recaptcha-custom-class"
                      onVerify={onVerify}
                      refreshReCaptcha={refreshReCaptcha}
                    />
                  </GoogleReCaptchaProvider>
                  <div className="d-grid mb-3 col-md-12 col-sm-12">
                    <button
                      disabled={submitted}
                      type="submit"
                      className="btn btn-primary btn-lg"
                    >
                      {submitted ? <Spinner color="light" /> : lang("t6")}
                    </button>
                    {/*<button disabled={submitted} type="submit" className="btn btn-primary btn-lg">*/}
                    {/*  {submitted ? <Spinner color="light"/> : "Sign up"}*/}
                    {/*</button>*/}
                  </div>
                  <div className="text-center">
                    <p>
                      {lang("t7")}{" "}
                      <Link className="link" to="/login">
                        {lang("t8")}
                      </Link>
                    </p>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};
